export default __webpack_public_path__ + "static/media/Song of Demise.b070948c.jpg";